module.exports = __webpack_public_path__ + "img/year.6526b4a2.svg";